export const editMutations = <const>{
	ZAPUJCKY_PRACOVNIK_SELECT_MAPPER: 'ZAPUJCKY_PRACOVNIK_SELECT_MAPPER',
	PROVOZOVNA_CHANGE: 'provozovnaChange',
};
export const editActions = <const>{
	KONTROLA_ZAPUJCKY: 'KONTROLA_ZAPUJCKY',
	PROVOZOVNA_CHANGE: 'provozovnaChange',
};
